import styled from 'styled-components';
import {GiRadioactive} from 'react-icons/gi';

export const Giradioactive = styled(GiRadioactive)`
  color: #002EFF;
`
